import { ComponentRef, Injectable, Type, ViewContainerRef } from '@angular/core';

@Injectable()
export class ComponentCreatorService {
  public createComponent<T>(container: ViewContainerRef, component: Type<T>): ComponentRef<T> {
    container.clear();
    return container.createComponent(component);
  }
}
